module.exports =
  base: '/manager'
  new: '/manager/new'
  order:
    base: '/manager/order'
    detail: '/manager/order/:orderId'
    cancel: '/manager/order/:orderId/cancel'
    claim: '/manager/order/:orderId/claim'
    changeAddress: '/manager/order/:orderId/changeAddress'
    testWebhook: '/manager/order/:orderId/testWebhook'
  cart:
    base: '/manager/cart'
    bulk: '/manager/user/carts'
    delete: '/manager/user/cart/:cartId/delete'
  reship:
    base: '/manager/reship'
    list: '/manager/list'
    detail: '/manager/reship/:reshipId/detail'
    orderItems: '/manager/reship/:reshipId/orderItems'
    request: '/manager/reship/:reshipId/request'
    cancel: '/manager/reship/:reshipId/cancel'
    view: '/manager/reship/:reshipId/view'
  design:
    base: '/manager/design'
    new: '/manager/design/new'
    detail: '/manager/design/:designId'
    changeName: '/manager/design/:designId/changeName'
    resolve: '/manager/design/:designId/resolve'
    requestVectorization: '/manager/design/:designId/requestVectorization'
  billing:
    base: '/manager/billing'
    detail: '/manager/billing/:billingId'
    transactions: '/manager/billing/:billingId/transactions'
    transactionsReport: '/manager/billing/:billingId/transactionsReport'
    balance: '/manager/billing/:billingId/balance'
    coupons: '/manager/billing/:billingId/coupons'
    storeCredits: '/manager/billing/:billingId/storeCredits'
    invoice:
      # base: '/manager/billing/:billingId/invoice'
      outstanding: '/manager/billing/:billingId/invoice/outstanding'
      detail: '/manager/billing/:billingId/invoice/:invoiceId'
      summary: '/manager/billing/:billingId/invoice/:invoiceId/summary'
      withdraw: '/manager/billing/:billingId/invoice/:invoiceId/withdraw'
      createCoupon: '/manager/billing/:billingId/invoice/createCoupon'
    pay: '/manager/billing/:billingId/pay'
    ach:
      base: '/manager/billing/:billingId/ach'
      setup: '/manager/billing/:billingId/ach/setup'
      verify: '/manager/billing/:billingId/ach/verify'
      delete: '/manager/billing/:billingId/ach/delete'
    paypal:
      setup: '/manager/billing/:billingId/paypal/setup'
      details: '/manager/billing/:billingId/paypal/details'
      confirm: '/manager/billing/:billingId/paypal/confirm'
    creditLineApplication:
      base: '/manager/billing/creditApplication'
      new: '/manager/billing/:billingId/creditApplication'
      apply: '/manager/billing/:billingId/creditApplication'
      update: '/manager/billing/:billingId/creditApplication/update'
      status: '/manager/billing/:billingId/creditApplication/status'
      tou: '/manager/billing/creditApplication/tou'

    # BILLING2
    payment:
      detail: '/manager/billing/:billingId/payment/:transactionId'
      summary: '/manager/billing/:billingId/payment/:transactionId/summary'
      stripe: '/manager/billing/:billingId/payment/stripe'
      paypal: '/manager/billing/:billingId/payment/paypal'
      ach: '/manager/billing/:billingId/payment/ach'
      credit: '/manager/billing/:billingId/payment/credit' # Sample or promotional credit


  settings:
    base: '/manager/settings'
    shipping: '/manager/settings/shipping'
    autoSwap: '/manager/settings/autoSwap'
  claim:
    base: '/manager/claim'
    detail: '/manager/claim/:claimId'
  upload:
    awsPolicy: '/manager/upload/awsPolicy'



// WEBPACK FOOTER //
// ./~/oo-routes/routes/manager.coffee